<template>
  <svg
    width="41"
    height="16"
    viewBox="0 0 41 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40.2031 16H0.203125C4.04486 16 7.72925 14.4739 10.4458 11.7574L18.7889 3.41421C19.57 2.63317 20.8363 2.63316 21.6173 3.41421L29.9605 11.7574C32.677 14.4739 36.3614 16 40.2031 16Z"
      fill="#F7F7F7"
    />
    <path
      d="M0 15.5V15.5C3.91477 15.5 7.67842 13.9888 10.5061 11.2814L18.8169 3.32429C19.5903 2.58377 20.8097 2.58377 21.5831 3.32429L29.8939 11.2814C32.7216 13.9888 36.4852 15.5 40.4 15.5V15.5"
      stroke="#E0E0E0"
    />
  </svg>
</template>

<script>
export default {
  name: 'TrianglePointerIcon',
}
</script>
